import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-toggler-text"
}
const _hoisted_2 = ["onKeyup", "onKeydown"]

import { ref, onMounted, nextTick } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'textToggler',
  props: {
    text: {
        type: String,
        required: true
    },
    editedField: {
        type: String,
        required: true
    }
},
  emits: ["completeEdit"],
  setup(__props, { emit: __emit }) {


const props = __props

const emits = __emit
const editableArea = ref<HTMLElement | null>(null)
const isEditing = ref<boolean>(false)


const startEdit = async () => {
    isEditing.value = true
    await nextTick();  // Wait for the next DOM update
    if(editableArea.value){
        editableArea.value.focus()
    }
}

// We need a helper function here. If the user presses enter, the editable area loses focus.
// That means if we assign the same function to the blur event and the keyup.enter, it will be called twice.
// This helper function will be called by the keyup.enter event and it will blur the field.

const blurField = () => {
    editableArea.value?.blur()
}

const completeEdit = () => {
    isEditing.value = false

    let newString = editableArea.value?.innerText.trim() || "";
    console.log(newString)

    if(newString === props.text){
        console.log("No change")
        return
    } else if (newString === "") {
        newString = props.text
        emits("completeEdit", newString)
    } else {
        newString = editableArea.value?.innerText.trim()
        emits("completeEdit", newString)
    }

}

const cancelEdit = () => {
    isEditing.value = false
}

onMounted(() => {

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "text-toggler-container",
    onDblclick: startEdit
  }, [
    (!isEditing.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(props.text), 1))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref_key: "editableArea",
          ref: editableArea,
          contenteditable: "true",
          tabIndex: "0",
          onBlurOnce: completeEdit,
          onKeyup: _withKeys(_withModifiers(blurField, ["prevent"]), ["enter"]),
          onKeydown: _withKeys(_withModifiers(cancelEdit, ["prevent"]), ["esc"]),
          class: "edit-area"
        }, _toDisplayString(props.text), 41, _hoisted_2))
  ], 32))
}
}

})